<template>
    <div>
      <canvas ref="signatureCanvas" width="500" height="300"></canvas>
      <button @click="clear">Clear</button>
      <button @click="save">Save</button>
    </div>
  </template>
  
  <script>
  import SignaturePad from 'signature_pad';
  
  export default {
    data() {
      return {
        signaturePad: null
      }
    },
    mounted() {
      const canvas = this.$refs.signatureCanvas;
      this.signaturePad = new SignaturePad(canvas);
    },
    methods: {
      clear() {
        this.signaturePad.clear();
      },
      save() {
        if (this.signaturePad.isEmpty()) {
          alert("Please provide a signature first.");
        } else {
          const dataURL = this.signaturePad.toDataURL();
          // Save the dataURL somewhere (e.g., send to server, store locally)
          console.log(dataURL);
        }
      }
    }
  }
  </script>
  
  <style scoped>
  canvas {
    border: 1px solid #000;
  }
  </style>


// WEBPACK FOOTER //
// src/components/kneexpert/TabComplain.vue